import {
  mailboxesOauthLogoutCreateMutation,
  mailboxesOauthLogoutLinkRetrieveOptions,
  mailboxesOutlookLinkRetrieveOptions
} from '@crm/api'
import Outlook from '@crm/assets/outlook.svg'
import { IntegrationCard } from '@shared/components'
import { useLocales } from '@shared/locales'

import { useMutation, useQuery } from '@tanstack/react-query'

import { useEffect } from 'react'

export const OutlookCard = () => {
  const { t } = useLocales()

  const { data, isLoading } = useQuery(mailboxesOutlookLinkRetrieveOptions())

  const {
    refetch: getLogoutLinkRefetch,
    isSuccess: isSuccessLogoutMicrosoft,
    data: getLogoutLinkData,
    isLoading: isPendingLogoutMicrosoft
  } = useQuery({
    ...mailboxesOauthLogoutLinkRetrieveOptions(),
    enabled: false
  })

  const { mutate: logout } = useMutation({
    ...mailboxesOauthLogoutCreateMutation()
  })

  useEffect(() => {
    if (isSuccessLogoutMicrosoft) {
      window.location.href = getLogoutLinkData?.logout_link
      logout({})
    }
  }, [isSuccessLogoutMicrosoft, getLogoutLinkData, logout])

  const onLogin = () => {
    window.location.href = data?.auth_link as string
  }
  const onLogout = () => getLogoutLinkRefetch()

  return (
    <IntegrationCard
      title="Outlook"
      logo={Outlook}
      description={t('outlook.description')}
      isConnected={data?.status === 'connected'}
      isPending={isPendingLogoutMicrosoft}
      isLoading={isLoading}
      onLogin={onLogin}
      onLogout={onLogout}
    />
  )
}
